import api from '@/api/index';

let actions = {
	getUserInfo({commit}) {
		//获取租户信息
		api.getTenantInfo({}).then(data => {
			if (data) {
				commit('setTenant', data);
			}
		});
	},

};

export default actions;


// WEBPACK FOOTER //
// ./src/store/actions.js